module.exports = __webpack_public_path__ + "img/navbar-city.eb82323d.png";